// extracted by mini-css-extract-plugin
module.exports = {"root":"card-info_root__1vuOV","icon":"card-info_icon__TaT2N","content":"card-info_content__1FPA-","title":"card-info_title__20nan","value":"card-info_value__NuVeg"};